import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DateAgoPipe } from './date-ago.pipe';
import { FunctionPipe } from './function.pipe';
import { CustomDateTimePipe } from './custom-date-time.pipe';
import { CustomDatePipe } from './custom-date.pipe';
import { CustomTimePipe } from './custom-time.pipe';

@NgModule({
  declarations: [
    DateAgoPipe,
    FunctionPipe,
    CustomDatePipe,
    CustomTimePipe,
    CustomDateTimePipe,
  ],
  imports: [CommonModule],
  exports: [
    DateAgoPipe,
    FunctionPipe,
    CustomDatePipe,
    CustomTimePipe,
    CustomDateTimePipe,
  ],
  providers: [
    DatePipe,
    DateAgoPipe,
    FunctionPipe,
    CustomDatePipe,
    CustomTimePipe,
    CustomDateTimePipe,
  ],
})
export class CommonPipeModule {}
